import { MultiString } from "../../../../../i18n/MultiString";
import { DataType } from "../../../../evaluators/DataType";
import { EvaluationResult } from "../../../../evaluators/EvaluationResult";
import { Evaluator } from "../../../../evaluators/Evaluator";
import { BinaryExpression } from "../../../../expressions/BinaryExpression";
import { RJParserMessages } from "../../../RJParserMessages";
import { DataTypes } from "../DataTypes";
import { BinaryFunction } from "./BinaryFunction";

export class Minus extends BinaryFunction
{
  _process():EvaluationResult<any>
  { 
    if ( this.typesAre( DataTypes.Number ) )
    {
      return EvaluationResult.withValue( this.leftNumber - this.rightNumber, DataTypes.Number );
    }
    else if ( this.typesAre( DataTypes.Vector3 ) )
    {
      let result = this.leftVector3.clone().sub( this.rightVector3 );

      return EvaluationResult.withValue( result, DataTypes.Vector3 );
    }

    return EvaluationResult.asError( this.binaryExpression, MultiString.resolve( RJParserMessages.parametersNotFitting ) +  " : Minus(-) "  );
  }
}